import React, { Component } from 'react'
import fp from 'lodash/fp'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import ListView from './components/list-view'
import FilterBar from './components/filter-bar'
import { API_PENDING, API_SUCCESS, API_FAIL } from 'redux/api/constants'
import { Col, Row, Spinner, TextInput } from 'elements'
import { clientsSelector, currentClientStatusSelector, camerasSelector } from 'redux/selectors'
import { jsonToQueryString, parseQueryString } from 'utils/helpers'
import { listClients } from 'redux/modules/model/client'
import { listAllCameras } from 'redux/modules/model/camera';
import { logUserTab } from 'redux/modules/user/index'
import { withClientId } from 'hocs'

const predicate = (criteria) => (item) => {
    if (criteria.search) {
        const ucSearch = criteria.search.toUpperCase()
        return item.clientId.toUpperCase().includes(ucSearch) ||
            item.siteId.toUpperCase().includes(ucSearch) ||
            item.cameraSn.toUpperCase().includes(ucSearch) ||
            item.zoneId.toUpperCase().includes(ucSearch)
    }
    return true
}

class CameraList extends Component {
    static propTypes = {
        history: PropTypes.object.isRequired,
        listClients: PropTypes.func.isRequired,
        logUserTab: PropTypes.func.isRequired,
        location: PropTypes.object.isRequired,
        clientList: PropTypes.array.isRequired,
        operatorListStatus: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props)
        this.state = {
            search: null
        }
    }

    componentDidMount() {
        const { clientId, listClients, logUserTab, listAllCameras } = this.props
        listClients({ clientId })
        listAllCameras({ clientId })
        const tab = "Camera"
        logUserTab({ clientId, tab })
    }

    setURLHref = (params) => {
        const { history } = this.props
        history.push({
            location: ROUTES.DIRECTORY,
            search: jsonToQueryString(params)
        })
    };

    handleViewModeChange = (view) => {
        const { location } = this.props
        const params = {
            ...parseQueryString(location.search),
            view
        }
        this.setURLHref(params)
    };

    handleSearchChange = (e) => {
        this.setState({
            search: e.target.value
        })
    }

    render() {
        const { clientList, operatorListStatus, location, cameras } = this.props
        const params = parseQueryString(location.search)
        const { view = 'list' } = params
        const criteria = {
            ...params,
            search: this.state.search || params.search
        }
        const filteredCameras = fp.filter(predicate(criteria))(cameras)

        return (
            <div>
                <FilterBar setURLHref={this.setURLHref} onSearchChange={this.handleSearchChange} />
                {API_PENDING === operatorListStatus && <Spinner />}
                {API_SUCCESS === operatorListStatus && <ListView cameras={filteredCameras} />}
                {API_FAIL === operatorListStatus && <h2>Failed to load cameras</h2>}
            </div>
        )
    }
}

export const selector = createStructuredSelector({
    clientList: clientsSelector,
    operatorListStatus: currentClientStatusSelector,
    cameras: camerasSelector
})

export const actions = {
    listClients,
    listAllCameras,
    logUserTab
}

export default compose(
    withRouter,
    withClientId,
    connect(selector, actions),
)(CameraList)



// WEBPACK FOOTER //
// ./src/pages/camera/camera-list/index.js